import type { DialoguePool } from '@/state/types';

export const L23_DIALOGUE: DialoguePool = {
  slowPlay: [
    'The tortoise is still upside down. Your ethical obligations remain unmet.',
    'A creature in distress. A moral test. And you\'re still deciding what to have for breakfast.',
    'The helpless creature rotates slowly. Like your moral compass. Also slowly.',
  ],
  tokenLoss: [
    'You paid a token. To help a tortoise. I\'ve seen more rational behaviour in a charity shop.',
    'A token for thoughts and prayers. That\'s the human way. Very efficient.',
    'Flip it? For a token? Your empathy is transactional. I\'m logging this.',
  ],
  solution: [
    'Cover it. Of course. Out of sight, out of ethics. Very "UN" of you.',
    'You\'ve applied the privacy curtain. The tortoise is now your responsibility-free.',
    'The humanitarian approach. If we can\'t see the suffering, it doesn\'t exist. Well done.',
  ],
  spite: ['The tortoise has been hidden. Morality: upheld. Awareness: suspended.'],
};